// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/demo_qr_code" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { freeTrialQrCode } from "./constants";
import type { FreeTrialQrCodeResult } from "./types";
import { isFreeTrialQrCodeResult } from "./validators";

export const getFreeTrialQrCode = reactQueryFetcherAdapter(
  freeTrialQrCode,
  (signal: AbortSignal): Promise<FreeTrialQrCodeResult> => {
    return fetch("/demo_qr_code", "GET", {}, { signal });
  },
  isFreeTrialQrCodeResult
);
